import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n,
    observable, inject, observer,
    mui, ui, theme, styled, pr,
    api, apiClient,
    debug
} from "aaa";

import { Auth } from "models/Auth";
import * as _ from "lodash";
import { Link } from "react-router-dom";



type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    auth: Auth
};


@i18n.injectIntl
@inject("auth")
@observer
export class Login extends React.Component<IProps, {}> {

    @observable
    formIsValid = true;

    @observable
    password: string;

    onSubmit = async (fields: any, resetForm: any, invalidateForm: any) => {
        const request = api.login(fields.username, fields.password);
        this.password = fields.password;
        try {
            const response = await apiClient.requestType(request);
            this.props.auth.token = response;

            this.props.auth.isAdmin = _.indexOf(response.scopes, "cms") >= 0;
            this.props.history.push("/interest-rates");
        } catch (error) {
            this.password = "";
            invalidateForm({ password: ui.__("error.loginFailed") });
        }
    }

    render() {
        return (
            <div style={{ padding: theme.MARGIN_BIG }}>
                <Formsy.Form
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                >
                    <form.FormsyText
                        name="username"
                        required={true}
                        floatingLabelText={ui.__("username")}
                        fullWidth={true}
                        validationError={ui.__("error.requiredField")}
                    />

                    <form.FormsyText
                        name="password"
                        type="password"
                        required={true}
                        validations="minLength:6"
                        floatingLabelText={ui.__("password")}
                        fullWidth={true}
                        validationError={ui.__("error.passwordTooShort")}
                        value={this.password}
                    />

                    <br /><br />
                    <Link
                        to="/request-password"
                        style={{
                            textDecoration: "none",
                            fontSize: "small",
                        }}
                    >
                        {ui.__("login.forgotpassword")}
                    </Link>

                    <br /><br />
                    {formHelpers.renderActionButton(ui.__("login"))}
                </Formsy.Form>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Login.tsx